import { reactive } from 'vue'
import axios from 'axios'

const ACTIVE_EMPLOYER_KEY = 'activeEmployerId'

function storedEmployerId () {
    const stored = localStorage.getItem(ACTIVE_EMPLOYER_KEY)

    return stored ? Number(stored) : null
}

export default reactive({
    user: null,
    loading: true,
    employers: [],
    // null betekent: alle bedrijven waar het account bij mag.
    activeEmployerId: storedEmployerId(),
    isLoggedIn () {
        return this.user !== null
    },
    hasMultipleEmployers () {
        return this.employers.length > 1
    },
    activeEmployer () {
        return this.employers.find(employer => employer.id === this.activeEmployerId) || null
    },
    setActiveEmployer (employerId) {
        this.activeEmployerId = employerId

        if (employerId === null) {
            localStorage.removeItem(ACTIVE_EMPLOYER_KEY)
        } else {
            localStorage.setItem(ACTIVE_EMPLOYER_KEY, employerId)
        }
    },
    loadUser () {
        this.loading = true

        axios
            .get('/api/account')
            .then(response => {
                this.user = response.data.data

                if (this.user.hasMultipleEmployers) {
                    this.loadEmployers()
                }
            })
            .catch(e => {

            })
            .finally(() => {
                this.loading = false
            })
    },
    loadEmployers () {
        axios
            .get('/api/account/employers')
            .then(response => {
                this.employers = response.data.data

                // Een bewaard filter op een bedrijf waar het account niet meer
                // bij mag, valt terug op alle bedrijven.
                if (this.activeEmployerId !== null && this.activeEmployer() === null) {
                    this.setActiveEmployer(null)
                }
            })
            .catch(e => {

            })
    }
})
